import { Steps } from 'primereact/steps';

const BoletasSteps = ({ activeIndex }) => {
    const items = [
        {
            label: 'Cliente'
        },
        {
            label: 'Cotización'
        }
    ];

    return (
        <>
            <Steps model={items} activeIndex={activeIndex} />
        </>
    );
};

export default BoletasSteps;